(() => {
  const tools = document.querySelector('[data-hm-deals-tools]');
  if (!tools) return;

  const form = tools.querySelector('[data-hm-deals-search-form]');
  const searchInput = tools.querySelector('[data-hm-deals-search-input]');
  const brandSelect = tools.querySelector('[data-hm-deals-brand]');
  const typeSelect = tools.querySelector('[data-hm-deals-type]');
  const sortSelect = tools.querySelector('[data-hm-deals-sort]');
  const clearSearchButton = tools.querySelector('[data-hm-deals-clear-search]');
  const status = tools.querySelector('[data-hm-deals-status]');
  const searchContext = tools.querySelector('[data-hm-deals-search-context]');
  const mobileToggle = tools.querySelector('[data-hm-deals-mobile-toggle]');
  const nativeGrid = document.getElementById('ProductGridContainer');
  const proxyMount = document.querySelector('[data-hm-deals-proxy-mount]');
  const facets = document.getElementById('main-collection-filters');
  if (!form || !searchInput || !sortSelect || !nativeGrid || !proxyMount) return;

  const proxyUrl = tools.dataset.proxyUrl || '/apps/hm-deals/search';
  const sessionUrl = tools.dataset.sessionUrl || '/apps/hm-deals/session';
  const infiniteScrollEnabled = tools.dataset.infiniteScroll === 'true';
  const ROOT_MARGIN = '700px 0px';
  let requestSerial = 0;
  let renderGeneration = 0;
  let audienceSessionPromise = null;
  let infiniteObserver = null;
  let infiniteLoading = false;
  let infiniteLoadedMore = false;
  let mainAbortController = null;
  let infiniteAbortController = null;

  const params = () => new URL(window.location.href).searchParams;
  const stateFromUrl = () => {
    const p = params();
    const rawSort = p.get('sort_by') || 'best-selling';
    const sort = ['hm-best-saving', 'best-saving', 'best-discount'].includes(rawSort) ? 'hm-best-discount' : rawSort;
    return {
      q: (p.get('deal_q') || '').trim(),
      vendor: (p.get('deal_brand') || '').trim(),
      productType: (p.get('deal_type') || '').trim(),
      sort,
      page: infiniteScrollEnabled ? 1 : Math.max(1, parseInt(p.get('deal_page') || '1', 10) || 1),
    };
  };

  // Every ON DEAL browse/search/sort state is authoritative through the same
  // tier-aware result layer. The native collection remains a safe fallback only.
  const isProxyState = () => true;

  function hasOption(select, value) {
    return Boolean(select && [...select.options].some((option) => option.value === value));
  }

  function syncControls(state) {
    searchInput.value = state.q;
    if (brandSelect) brandSelect.value = hasOption(brandSelect, state.vendor) ? state.vendor : '';
    if (typeSelect) typeSelect.value = hasOption(typeSelect, state.productType) ? state.productType : '';
    sortSelect.value = hasOption(sortSelect, state.sort) ? state.sort : 'best-selling';
  }

  function updateSearchClear(value = searchInput.value, appliedValue = stateFromUrl().q) {
    if (!clearSearchButton) return;
    clearSearchButton.hidden = !String(value || '').trim() && !String(appliedValue || '').trim();
  }

  function hideSearchContext() {
    if (!searchContext) return;
    searchContext.textContent = '';
    searchContext.hidden = true;
  }

  function updateSearchContext(state) {
    if (!searchContext) return;
    const query = String(state?.q || '').trim();
    if (!query) {
      hideSearchContext();
      return;
    }
    searchContext.textContent = `Showing results for “${query}”`;
    searchContext.hidden = false;
  }

  function publicUrl(nextState) {
    const url = new URL(window.location.href);
    const p = url.searchParams;
    if (nextState.q) p.set('deal_q', nextState.q); else p.delete('deal_q');
    if (nextState.vendor) p.set('deal_brand', nextState.vendor); else p.delete('deal_brand');
    if (nextState.productType) p.set('deal_type', nextState.productType); else p.delete('deal_type');
    p.delete('deal_availability');
    if (nextState.sort && nextState.sort !== 'best-selling') p.set('sort_by', nextState.sort); else p.delete('sort_by');
    // Infinite-scroll browsing keeps the public URL anchored to the result set,
    // while non-infinite mode retains explicit page links.
    if (!infiniteScrollEnabled && nextState.page && nextState.page > 1) p.set('deal_page', String(nextState.page)); else p.delete('deal_page');
    [...p.keys()].filter((key) => key.startsWith('filter.')).forEach((key) => p.delete(key));
    p.delete('page');
    return url;
  }

  async function loadAudienceSession({ force = false } = {}) {
    if (!force && audienceSessionPromise) return audienceSessionPromise;
    audienceSessionPromise = (async () => {
      let html = '';
      if (!force && window.__hmDealsSessionTextPromise) {
        html = await window.__hmDealsSessionTextPromise;
      }
      if (!html) {
        const response = await fetch(sessionUrl, { headers:{ Accept:'text/html' }, credentials:'same-origin' });
        if (!response.ok) throw new Error(`Deals session returned ${response.status}`);
        html = await response.text();
      }
      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const node = template.content.querySelector('[data-hm-deals-session]');
      const token = node?.dataset?.token || '';
      if (!node || !token) throw new Error('Deals session response was not recognised');
      return { token, audience:node.dataset.audience || 'a' };
    })().catch((error) => {
      audienceSessionPromise = null;
      throw error;
    });
    return audienceSessionPromise;
  }

  function proxyRequestUrl(state, token, { minimal = false } = {}) {
    const p = new URLSearchParams();
    if (state.q) p.set('q', state.q);
    if (state.vendor) p.set('vendor', state.vendor);
    if (state.productType) p.set('type', state.productType);
    p.set('sort', state.sort || 'best-selling');
    p.set('page', String(state.page || 1));
    p.set('deal_token', token);
    if (!minimal) {
      p.set('hm_card_section_id', tools.dataset.sectionId || 'hm-deals');
      p.set('image_ratio', tools.dataset.imageRatio || 'adapt');
      p.set('image_shape', tools.dataset.imageShape || 'default');
      p.set('show_secondary_image', tools.dataset.showSecondaryImage || 'false');
      p.set('show_vendor', tools.dataset.showVendor || 'false');
      p.set('show_rating', tools.dataset.showRating || 'false');
      p.set('quick_add', tools.dataset.quickAdd || 'none');
      p.set('columns_mobile', tools.dataset.columnsMobile || '2');
      p.set('columns_desktop', tools.dataset.columnsDesktop || '4');
    }
    return `${proxyUrl}?${p.toString()}`;
  }

  async function requestProxy(state, { minimal = false, refreshSession = false, signal } = {}) {
    const session = await loadAudienceSession({ force:refreshSession });
    const response = await fetch(proxyRequestUrl(state, session.token, { minimal }), {
      headers:{ Accept:'text/html' },
      credentials:'same-origin',
      signal,
    });
    if (response.status === 401 && !refreshSession) return requestProxy(state, { minimal, refreshSession:true, signal });
    if (!response.ok) throw new Error(`Deals search returned ${response.status}`);
    const html = await response.text();
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    const result = template.content.querySelector('[data-hm-deals-proxy-response]');
    if (!result) {
      console.warn('[Hair & More Deals] unrecognised proxy response', html.slice(0, 300));
      throw new Error('Deals search response was not recognised');
    }
    return result;
  }

  function setBusy(busy, message = '') {
    tools.classList.toggle('hm-deals-tools--loading', busy);
    tools.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (status) status.textContent = message;
  }

  function updateCounts(total) {
    const label = `${total} ${total === 1 ? 'deal' : 'deals'}`;
    document.querySelectorAll('#ProductCountDesktop, #ProductCount, .product-count__text span').forEach((node) => {
      node.textContent = label;
    });
  }

  function renderPagination(state, page, pages) {
    if (pages <= 1) return '';
    const item = (target, label, extraClass = '') => {
      const url = publicUrl({ ...state, page: target });
      return `<li><a class="pagination__item link ${extraClass}" href="${url.pathname}${url.search}" data-hm-deals-page="${target}" aria-label="${label}">${label}</a></li>`;
    };
    const items = [];
    if (page > 1) items.push(item(page - 1, 'Previous', 'pagination__item-arrow'));
    const start = Math.max(1, page - 2);
    const end = Math.min(pages, page + 2);
    if (start > 1) items.push(item(1, '1'));
    if (start > 2) items.push('<li><span class="pagination__item">…</span></li>');
    for (let n = start; n <= end; n += 1) {
      if (n === page) items.push(`<li><span class="pagination__item pagination__item--current light" aria-current="page">${n}</span></li>`);
      else items.push(item(n, String(n)));
    }
    if (end < pages - 1) items.push('<li><span class="pagination__item">…</span></li>');
    if (end < pages) items.push(item(pages, String(pages)));
    if (page < pages) items.push(item(page + 1, 'Next', 'pagination__item-arrow'));
    return `<div class="pagination-wrapper"><nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">${items.join('')}</ul></nav></div>`;
  }

  function disconnectInfiniteObserver() {
    if (infiniteObserver) infiniteObserver.disconnect();
    infiniteObserver = null;
  }

  function abortInfiniteRequest() {
    if (infiniteAbortController) infiniteAbortController.abort();
    infiniteAbortController = null;
    infiniteLoading = false;
  }

  function removeInfiniteGridLoader(collection) {
    collection?.querySelectorAll('[data-hm-deals-grid-loader]').forEach((node) => node.remove());
  }

  function removeInfiniteGridEnd(collection) {
    collection?.querySelectorAll('[data-hm-deals-grid-end]').forEach((node) => node.remove());
    collection?.querySelector('[data-hm-deals-infinite-sentinel]')?.classList.remove('has-grid-end-card');
  }

  function ensureInfiniteGridEnd(collection, message = 'All deals loaded.') {
    const grid = collection?.querySelector('[data-hm-deals-proxy-grid]');
    if (!grid) return;
    let item = grid.querySelector('[data-hm-deals-grid-end]');
    if (!item) {
      item = document.createElement('li');
      item.className = 'grid__item hm-infinite-scroll__grid-end';
      item.setAttribute('data-hm-deals-grid-end', '');
      item.setAttribute('aria-hidden', 'true');
      item.innerHTML = `
        <div class="hm-infinite-scroll__grid-end-card">
          <span class="hm-infinite-scroll__grid-end-copy" data-hm-deals-grid-end-copy></span>
        </div>
      `;
      grid.appendChild(item);
    }
    const copy = item.querySelector('[data-hm-deals-grid-end-copy]');
    if (copy) copy.textContent = message;
    ensureInfiniteStatus(collection).classList.add('has-grid-end-card');
  }

  function ensureInfiniteGridLoader(collection) {
    removeInfiniteGridEnd(collection);
    const grid = collection?.querySelector('[data-hm-deals-proxy-grid]');
    if (!grid || grid.querySelector('[data-hm-deals-grid-loader]')) return;
    const item = document.createElement('li');
    item.className = 'grid__item hm-infinite-scroll__grid-loader';
    item.setAttribute('data-hm-deals-grid-loader', '');
    item.setAttribute('aria-hidden', 'true');
    item.innerHTML = `
      <div class="hm-infinite-scroll__grid-loader-card">
        <span class="hm-infinite-scroll__grid-loader-spinner" aria-hidden="true"></span>
        <span class="hm-infinite-scroll__grid-loader-copy">Loading more deals…</span>
      </div>
    `;
    grid.appendChild(item);
  }

  function ensureInfiniteStatus(collection) {
    let sentinel = collection?.querySelector('[data-hm-deals-infinite-sentinel]');
    if (sentinel) return sentinel;
    sentinel = document.createElement('div');
    sentinel.className = 'hm-infinite-scroll';
    sentinel.setAttribute('data-hm-deals-infinite-sentinel', '');
    sentinel.setAttribute('data-state', 'idle');
    sentinel.setAttribute('role', 'status');
    sentinel.setAttribute('aria-live', 'polite');
    sentinel.setAttribute('aria-atomic', 'true');
    sentinel.innerHTML = `
      <div class="hm-infinite-scroll__status">
        <span class="hm-infinite-scroll__spinner" aria-hidden="true"></span>
        <span data-hm-deals-infinite-message></span>
        <button class="hm-infinite-scroll__retry" type="button" data-hm-deals-infinite-retry hidden>Try again</button>
      </div>
    `;
    collection.appendChild(sentinel);
    return sentinel;
  }

  function setInfiniteState(collection, state, message = '') {
    if (!collection) return;
    const sentinel = ensureInfiniteStatus(collection);
    sentinel.classList.remove('is-loading', 'is-error', 'is-end');
    sentinel.dataset.state = state;
    const messageNode = sentinel.querySelector('[data-hm-deals-infinite-message]');
    const retry = sentinel.querySelector('[data-hm-deals-infinite-retry]');

    if (state === 'loading') {
      sentinel.classList.add('is-loading');
      ensureInfiniteGridLoader(collection);
      if (messageNode) messageNode.textContent = message || 'Loading more deals…';
    } else {
      removeInfiniteGridLoader(collection);
      if (state === 'error') {
        removeInfiniteGridEnd(collection);
        sentinel.classList.add('is-error');
        if (messageNode) messageNode.textContent = message || 'More deals could not be loaded.';
      } else if (state === 'end') {
        const endMessage = message || 'All deals loaded.';
        sentinel.classList.add('is-end');
        ensureInfiniteGridEnd(collection, endMessage);
        if (messageNode) messageNode.textContent = endMessage;
      } else {
        removeInfiniteGridEnd(collection);
        if (messageNode) messageNode.textContent = '';
      }
    }
    if (retry) retry.hidden = state !== 'error';
  }

  function appendInfiniteSentinel(collection, state, page, pages, generation, { showEnd = false } = {}) {
    disconnectInfiniteObserver();
    const sentinel = ensureInfiniteStatus(collection);
    sentinel.dataset.nextPage = String(page + 1);

    if (!infiniteScrollEnabled) {
      sentinel.remove();
      return;
    }
    if (page >= pages) {
      setInfiniteState(collection, showEnd || infiniteLoadedMore ? 'end' : 'idle');
      return;
    }
    setInfiniteState(collection, 'idle');

    if (!('IntersectionObserver' in window)) {
      sentinel.remove();
      collection.insertAdjacentHTML('beforeend', renderPagination(state, page, pages));
      return;
    }

    infiniteObserver = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      const nextPage = Math.max(1, parseInt(sentinel.dataset.nextPage || '', 10) || page + 1);
      loadMoreProxy(state, nextPage, generation);
    }, { rootMargin:ROOT_MARGIN });
    infiniteObserver.observe(sentinel);
  }

  function emptyMessage(state) {
    const filtered = Boolean(state.q || state.vendor || state.productType);
    if (!filtered) return '<div class="title-wrapper center"><h2 class="title title--primary">There are no deals available right now.</h2></div>';
    return '<div class="title-wrapper center"><h2 class="title title--primary">No deals match those filters.</h2><p>Try changing the search or filters above.</p></div>';
  }

  function renderProxyResponse(responseNode, state, { append = false, generation = renderGeneration } = {}) {
    const total = Math.max(0, parseInt(responseNode.dataset.total || '0', 10) || 0);
    const page = Math.max(1, parseInt(responseNode.dataset.page || '1', 10) || 1);
    const pages = Math.max(1, parseInt(responseNode.dataset.pages || '1', 10) || 1);
    const grid = responseNode.querySelector('[data-hm-deals-proxy-grid]');

    let collection = proxyMount.querySelector('.collection');
    let existingGrid = proxyMount.querySelector('[data-hm-deals-proxy-grid]');

    if (append && collection && existingGrid && grid) {
      removeInfiniteGridLoader(collection);
      [...grid.children].forEach((item) => existingGrid.appendChild(document.importNode(item, true)));
      proxyMount.querySelectorAll('.pagination-wrapper').forEach((node) => node.remove());
      infiniteLoadedMore = true;
      appendInfiniteSentinel(collection, state, page, pages, generation, { showEnd:page >= pages });
      document.dispatchEvent(new CustomEvent('hm:deals:rendered', { detail:{ total, page, pages, append:true } }));
      return;
    }

    proxyMount.innerHTML = '';
    infiniteLoadedMore = false;
    collection = document.createElement('div');
    collection.className = `collection hm-infinite-scroll--ready${proxyMount.dataset.pageWidth === 'true' ? ' page-width' : ''}`;
    if (!total || !grid) {
      collection.classList.add('collection--empty');
      collection.innerHTML = emptyMessage(state);
    } else {
      existingGrid = document.importNode(grid, true);
      existingGrid.setAttribute('data-hm-infinite-scroll-grid', '');
      collection.appendChild(existingGrid);
      if (infiniteScrollEnabled) appendInfiniteSentinel(collection, state, page, pages, generation);
      else collection.insertAdjacentHTML('beforeend', renderPagination(state, page, pages));
    }
    proxyMount.appendChild(collection);
    updateCounts(total);
    updateSearchClear(state.q);
    updateSearchContext(state);
    nativeGrid.hidden = true;
    proxyMount.hidden = false;
    document.documentElement.classList.remove('hm-deals-initial-query-pending');
    if (facets) facets.classList.add('hm-deals-native-facets--proxy-active');
    document.dispatchEvent(new CustomEvent('hm:deals:rendered', { detail:{ total, page, pages, append:false } }));
  }

  async function loadMoreProxy(state, nextPage, generation) {
    if (!infiniteScrollEnabled || infiniteLoading || generation !== renderGeneration) return;
    const collection = proxyMount.querySelector('.collection');
    if (!collection) return;
    infiniteLoading = true;
    disconnectInfiniteObserver();
    infiniteAbortController = new AbortController();
    setInfiniteState(collection, 'loading');
    try {
      const result = await requestProxy({ ...state, page:nextPage }, { signal:infiniteAbortController.signal });
      if (generation !== renderGeneration) return;
      renderProxyResponse(result, { ...state, page:nextPage }, { append:true, generation });
    } catch (error) {
      if (error?.name === 'AbortError' || generation !== renderGeneration) return;
      setInfiniteState(collection, 'error', 'More deals could not be loaded.');
      console.warn('[Hair & More Deals] infinite load failed', error);
    } finally {
      infiniteLoading = false;
      infiniteAbortController = null;
    }
  }

  async function loadProxy(state, { push = false, replace = false, loadingMessage = 'Loading deals…' } = {}) {
    const serial = ++requestSerial;
    const generation = ++renderGeneration;
    abortInfiniteRequest();
    disconnectInfiniteObserver();
    if (mainAbortController) mainAbortController.abort();
    mainAbortController = new AbortController();
    syncControls(state);
    updateSearchClear(state.q);
    // Keep the prior/applied search label out of view while a new result set is
    // being resolved. renderProxyResponse() restores it only after success.
    hideSearchContext();
    const url = publicUrl(state);
    if (push) history.pushState({ hmDeals:true }, '', `${url.pathname}${url.search}`);
    else if (replace) history.replaceState({ hmDeals:true }, '', `${url.pathname}${url.search}`);

    setBusy(true, loadingMessage);
    try {
      let result;
      try {
        result = await requestProxy(state, { signal:mainAbortController.signal });
      } catch (firstError) {
        if (firstError?.name === 'AbortError') throw firstError;
        console.warn('[Hair & More Deals] primary request failed; retrying minimal proxy response', firstError);
        result = await requestProxy(state, { minimal:true, signal:mainAbortController.signal });
      }
      if (serial !== requestSerial) return;
      renderProxyResponse(result, state, { generation });
      setBusy(false, '');
    } catch (error) {
      if (error?.name === 'AbortError' || serial !== requestSerial) return;
      proxyMount.hidden = true;
      document.documentElement.classList.remove('hm-deals-initial-query-pending');
      nativeGrid.hidden = false;
      if (facets) facets.classList.remove('hm-deals-native-facets--proxy-active');
      setBusy(false, 'Deals search is temporarily unavailable. Showing the standard Deals list instead.');
      console.warn('[Hair & More Deals]', error);
    } finally {
      if (serial === requestSerial) mainAbortController = null;
    }
  }

  function stateFromControls() {
    const current = stateFromUrl();
    return {
      ...current,
      q:searchInput.value.trim(),
      vendor:brandSelect ? brandSelect.value : '',
      productType:typeSelect ? typeSelect.value : '',
      sort:sortSelect.value || 'best-selling',
      page:1,
    };
  }

  function loadFromControls(message = 'Filtering deals…') {
    loadProxy(stateFromControls(), { push:true, loadingMessage:message });
  }

  if (mobileToggle) mobileToggle.addEventListener('click', () => {
    const open = !tools.classList.contains('hm-deals-tools--mobile-open');
    tools.classList.toggle('hm-deals-tools--mobile-open', open);
    mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    loadFromControls('Searching deals…');
  });

  if (brandSelect) brandSelect.addEventListener('change', () => loadFromControls('Filtering deals…'));
  if (typeSelect) typeSelect.addEventListener('change', () => loadFromControls('Filtering deals…'));
  sortSelect.addEventListener('change', () => loadFromControls('Sorting deals…'));

  searchInput.addEventListener('input', () => updateSearchClear(searchInput.value));

  if (clearSearchButton) clearSearchButton.addEventListener('click', () => {
    const appliedSearch = stateFromUrl().q;
    searchInput.value = '';
    updateSearchClear('');
    if (!appliedSearch) {
      searchInput.focus();
      return;
    }
    const next = stateFromControls();
    loadProxy({ ...next, q:'', page:1 }, { push:true, loadingMessage:'Loading deals…' });
  });

  proxyMount.addEventListener('click', (event) => {
    const retry = event.target.closest('[data-hm-deals-infinite-retry]');
    if (retry) {
      event.preventDefault();
      const sentinel = retry.closest('[data-hm-deals-infinite-sentinel]');
      const nextPage = Math.max(2, parseInt(sentinel?.dataset?.nextPage || '2', 10) || 2);
      loadMoreProxy(stateFromUrl(), nextPage, renderGeneration);
      return;
    }

    const link = event.target.closest('[data-hm-deals-page]');
    if (!link) return;
    event.preventDefault();
    const current = stateFromUrl();
    loadProxy({ ...current, page:Math.max(1, parseInt(link.dataset.hmDealsPage || '1', 10) || 1) }, { push:true, loadingMessage:'Loading deals…' });
    tools.scrollIntoView({ behavior:'smooth', block:'start' });
  });

  window.addEventListener('popstate', () => loadProxy(stateFromUrl(), { loadingMessage:'Loading deals…' }));

  const initial = stateFromUrl();
  syncControls(initial);
  updateSearchClear(initial.q);
  hideSearchContext();
  if (isProxyState(initial)) loadProxy(initial, { replace:true, loadingMessage:'Loading deals…' });
})();
